import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { getContrastingTextColor } from '../../../Constants/Colors';
import { Scheme } from '../../../Constants/System';
import { Link } from 'react-router-dom';
import { CombineClasses } from '../../../Utility/ReactUtils';
export default function ContextMenu(props) {
    const { items, close, className } = props;
    return (_jsx(Container, { className: CombineClasses(className, 'context-menu-container'), children: items.map((item, index) => {
            return _jsx(ContextMenuItem, { ...item, close: close }, index);
        }) }));
}
const Container = styled.div `
	background-color: ${(props) => props.theme.palette.shade5};
	box-shadow: 0px 5px 15px #0000004d;
`;
function ContextMenuItem(props) {
    const handleCallback = (e) => {
        if (!props.to) {
            e.stopPropagation();
        }
        props.callback?.();
        props.close?.();
    };
    const scheme = props.scheme ? props.scheme : Scheme.primary;
    const text = props.text ? props.text : null;
    const children = props.children ? props.children : null;
    if (props.to) {
        return (_jsxs(ContextMenuItemLink, { scheme: scheme, to: props.to, onClick: handleCallback, className: "context-menu-item", children: [text, children] }));
    }
    return (_jsxs(StyledContextMenuItem, { scheme: scheme, onClick: handleCallback, className: "context-menu-item", children: [text, children] }));
}
const getStyles = (props) => {
    return `
		background-color: ${props.theme.schemes[props.scheme].passive};
		color: ${getContrastingTextColor(props.theme.schemes[props.scheme].passive)};
		min-width: 200px;
		display: block;
		text-align: left;
		padding: ${props.theme.spacing.sm} ${props.theme.spacing.md};
		cursor: pointer;
		white-space: nowrap;

		&:hover {
			cursor: pointer;
			background-color: ${props.theme.schemes[props.scheme].hover};
			color: ${getContrastingTextColor(props.theme.schemes[props.scheme].hover)};
		}
	`;
};
const StyledContextMenuItem = styled.div `
	${(props) => getStyles(props)}
`;
const ContextMenuItemLink = styled(Link) `
	${(props) => getStyles(props)}
	text-decoration: none;
`;
//# sourceMappingURL=ContextMenu.js.map